/* global Ad */
import inputWithPlaceholder from '@PROJECT_ROOT/assets/desktop/js/search/inputWithPlaceholder';

/**
 * @param {object} state PHP varijable
 */
export default function initLighthouseSearchForm(state) {
    Ad.Datepicker.initRange(
        '#lighthouseSearchForm_from',
        '#lighthouseSearchForm_to',
        datepickerOptions(state.datepickerOptions),
    );

    inputWithPlaceholder('lighthouseSearchForm_region');
    inputWithPlaceholder('lighthouseSearchForm_persons');

    initFormEvents(state);
}

function initFormEvents(state) {
    document.getElementById('homePageLighthouseSearch').addEventListener('submit', (event) => {
        event.preventDefault();
        const ajaxData = Ad.Search.getSearchFormAjaxData('homePageLighthouseSearch');
        Ad.Search.fetchOptimalUrlAndRedirect(ajaxData, state.lighthouseQueryOptimiseUrl);
    });
}

function datepickerOptions(options) {
    return {
        openToAfterSelectingFromDate: true,
        allowKeyboardInput: false,
        deleteButton: { text: options.deleteText },
        currentText: options.currentText,
    };
}
